/**
 * SDK-specific error classes
 */

export class MemoryIntelligenceError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "MemoryIntelligenceError";
  }
}

export class ConfigurationError extends MemoryIntelligenceError {
  constructor(message: string) {
    super(message);
    this.name = "ConfigurationError";
  }
}

export class MemoryNotFoundError extends MemoryIntelligenceError {
  constructor(memoryId: string) {
    super(`Memory not found: ${memoryId}`);
    this.name = "MemoryNotFoundError";
  }
}

export class DatabaseError extends MemoryIntelligenceError {
  constructor(message: string, public originalError?: Error) {
    super(message);
    this.name = "DatabaseError";
  }
}

export class EmbeddingError extends MemoryIntelligenceError {
  constructor(message: string, public originalError?: Error) {
    super(message);
    this.name = "EmbeddingError";
  }
}

export class ValidationError extends MemoryIntelligenceError {
  constructor(message: string) {
    super(message);
    this.name = "ValidationError";
  }
}
